var _path, _path2, _circle, _circle2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootprintPublic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 80H76.2991M55 80H76.2991M76.2991 69V80",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.787 79.311L108.34 79.8412L109.074 80.0631C112.548 81.1132 117.737 82.9759 121.999 85.1209C124.145 86.2009 125.907 87.2791 127.086 88.2728C128.095 89.1245 128.274 89.5714 128.3 89.6063V93.5002C128.3 94.4941 127.494 95.3 126.5 95.3H35C34.0059 95.3 33.2 94.4941 33.2 93.5V82.2997C33.2 82.0171 33.2629 81.8109 33.3221 81.6961C33.3496 81.6426 33.3725 81.6157 33.3826 81.6052C33.3911 81.5964 33.3964 81.5928 33.4042 81.5887L31.9251 78.7511L33.4042 81.5887C34.7488 80.8879 36.7251 80.2 39 80.2H40.2852L41.2134 79.311L53.1623 67.867C56.2895 64.8719 60.4524 63.2 64.7826 63.2H84.2174C88.5476 63.2 92.7105 64.8719 95.8377 67.867L107.787 79.311Z",
    stroke: "white",
    strokeWidth: 6.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 98,
    r: 8.6,
    fill: "#5D38E5",
    stroke: "white",
    strokeWidth: 4.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 98,
    r: 8.6,
    fill: "#5D38E5",
    stroke: "white",
    strokeWidth: 4.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.029 96.9709C152.402 62.161 131.781 26.3438 96.9711 16.9709C62.1612 7.59805 26.344 28.2188 16.9711 63.0287C7.59822 97.8386 28.219 133.656 63.0289 143.029C97.8388 152.402 133.656 131.781 143.029 96.9709Z",
    stroke: "white",
    strokeWidth: 6.4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.286 55.2577L125.44 33.1035",
    stroke: "white",
    strokeWidth: 6.4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7812 125.76L103.286 55.2559",
    stroke: "white",
    strokeWidth: 6.4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprintPublic);
export default __webpack_public_path__ + "static/media/footprint_public.d041cbbeffe13f290e115d0fc6110e01.svg";
export { ForwardRef as ReactComponent };